/**
 * modal
 */

import $ from 'jquery';
import VanillaModal from 'vanilla-modal';
import Page from 'js/lib/page';

export default class Modal extends Page {
  init() {
    this.modal = new VanillaModal({
      modal: '.modal',
      modalInner: '.modal__inner',
      modalContent: '.modal__content',
      loadClass: 'modal-init'
    });

    this.elements({
      title: '.js-modal-title'
    });

    this.events();
  }
  events() {
    this.$.document.on('click', '[data-modal-close]', () => this.close());
    this.$.document.on('click', '[data-modal]', e => this.open(e));
  }
  open(e) {
    const $target = $(e.target);
    const id = $target.data('modal');
    const name = `#modal-${id}`;
    const title = $(name).data('title');

    this.$.title.text(title);

    this.modal.open(name);
  }
  close() {
    setTimeout(() => {
      this.modal.close();
    }, 200);
  }
}

Page.make(Modal, '.js-modal');
